var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"scroll-to-top",class:{'active': _vm.active},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.scrollToTop($event)}}},[_c('i',{staticClass:"fas fa-arrow-up"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fbdb20e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/App/Partials/ScrollToTop.vue
// module id = 203
// module chunks = 35